import {IHostMaps} from '@xc/hiya-host/es/lib/types'

// 域名覆盖， 由于 HigoHostMaps 配置被发布为npm包
const replaceHostConfig = (HigoHostMaps: IHostMaps) => {
  try {
    const prodMap = HigoHostMaps.prod
    prodMap.forEach((item) => {
      // version: "version-hiya-web.higochat.net"  -> version-web.higochat.net
      // eslint-disable-next-line no-param-reassign
      item.version = 'version-web.higochat.net'
    })
  } catch (error) {
    console.log('error :>> ', error)
  }
}

export default replaceHostConfig
